import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const term = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach((el) => {
      const text = el.innerText.toLowerCase()
      el.classList.toggle("hidden", term && !text.includes(term))
    })
  }
}
